<template>
  <div class="tolerance-page">
    <div class="container">
      <h1 class="page-title">CNC Machining Capabilities</h1>

      <div class="tolerance-table-wrapper">
        <table class="tolerance-table">
          <tbody>
            <tr>
              <td>Tolerance</td>
              <td>Linear dimension: +/-0.025 mm<br>
                Hole diameters (not reamed): +/- 0.025 mm<br>
                Shaft diameters: +/- 0.025 mm</td>
            </tr>
            <tr>
              <td>Threads and holes</td>
              <td>Our cnc machines can adapt to any standard thread size and customized threads</td>
            </tr>
            <tr>
              <td>Min. feature size</td>
              <td>The minimum feature size we make is 0.5 mm, depending on the geometry of the product and the materials
                being used</td>
            </tr>
            <tr>
              <td>Burrs and chamfers</td>
              <td>Deburring by default, chamfering according to your requirements</td>
            </tr>
            <tr>
              <td>Surface Finish</td>
              <td>The standard finish is Ra 1.2 or better, you can specify surface finishing options</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="disclaimer-text">
        Part lengths of up to 43" are available on our platform process dependent. Please inquire about anything larger.
        XCL offers different general tolerance options from 0.01mm to 0.05mm and you can also specify available
        tolerances according to ISO 2768-mK.
      </p>

      <div class="button-wrapper">
        <button class="getQuote-btn" @click="$router.push('/quote')">Get Instant Quote</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tolerance'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

.tolerance-page {
  /* ✨ 利用 clamp 实现动态内边距：最小 30px，按 5vw 缩放，最大 60px */
  padding: clamp(30px, 5vw, 60px) 20px;
  background-color: #ffffff;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
}

/* 标题样式 */
.page-title {
  /* ✨ 标题动态字号：手机端最小 26px，大屏最大 36px */
  font-size: clamp(26px, 4vw, 36px);
  color: #333333;
  margin: 0 0 clamp(20px, 4vw, 30px);
  font-weight: 600;
}

.tolerance-table-wrapper {
  width: 100%;
  margin-bottom: 30px;
  overflow-x: auto; /* ✨ 允许横向滑动 */
  -webkit-overflow-scrolling: touch; /* ✨ 让 iOS 设备上滑动更顺滑 */
}

.tolerance-table {
  width: 100%;
  min-width: 600px; /* ✨ 核心：限制表格最小宽度，防止在极小手机屏幕上文字被挤压变形 */
  border-collapse: collapse;
  background-color: #ffffff;
  table-layout: fixed;
}

.tolerance-table thead tr {
  background-color: #f0f4f5;
}

.tolerance-table th,
.tolerance-table td {
  padding: 20px 15px;
  text-align: center;
  border: 1px solid #e5e7eb;
  color: #333333;
  font-size: 16px;
  line-height: 1.5;
}

.tolerance-table th {
  font-weight: 600;
}

.tolerance-table td:first-child {
  font-weight: 600; /* ✨ 左侧标题稍微加粗一点更好看 */
  width: 25%; /* ✨ 桌面端比例调整为 25% : 75% 更协调 */
}

.tolerance-table td:last-child {
  width: 75%;
  text-align: center; /* ✨ PC端（不滑动时）保持居中 */
}

/* 说明文字 */
.disclaimer-text {
  font-size: clamp(14px, 2.5vw, 16px); /* ✨ 动态字体大小 */
  color: #666666;
  line-height: 1.6;
  margin: 0 auto 35px;
  max-width: 800px;
}

/* 按钮容器 */
.button-wrapper {
  display: flex;
  justify-content: center;
}

.getQuote-btn {
  background-color: #16bc9c;
  color: #ffffff;
  border: none;
  padding: 14px 30px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.getQuote-btn:hover {
  background-color: #13a88b;
}

/* ================= 响应式适配 ================= */
@media (max-width: 768px) {
  .tolerance-table th,
  .tolerance-table td {
    padding: 15px 10px;
    font-size: 14px;
  }

  /* ✨ 在移动端重新分配列宽，给左侧更多空间 */
  .tolerance-table td:first-child {
    width: 35%;
    text-align: center; /* ✨ 移动端左侧标题也左对齐，排版更清晰 */
  }

  .tolerance-table td:last-child {
    width: 65%;
    text-align: left; /* ✨ 核心修改：当屏幕变小（出现滑动）时，强制左对齐，提升阅读体验 */
  }
}
</style>